import { Component, Input } from '@angular/core';
import { UserService } from '../_services/user.service';

import { NewUser } from '../_models/new.user';
import { User } from '../_models/user';

@Component({
  moduleId: module.id,
  templateUrl: 'create.user.component.html'
})

export class CreateUserComponent {
  model: User;
  error: string;
  loading: boolean;
  success: boolean;

  constructor(
    private userService: UserService
  ){}

  createUser(model: NewUser) {
    this.error = null;
    this.loading = true;
    this.success = false;

    this.userService.createUser(model)
      .then(user => {
        this.success = true;
        this.model = user;
      })
      .catch(err => {
        this.error = JSON.parse(err._body).error;
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/create.user.component.ts